import { FunctionComponent, Ref } from 'react'

import styled, { css } from 'styled-components'

import { desktopCSS } from '@measures/responsive'

interface SummaryContainerProps {
  children: React.ReactNode
  isExpanded?: boolean
  height?: number
  id?: string
  isLoading?: boolean
  ref?: Ref<HTMLDivElement>
}

type SectionSummaryWrapperProps = Pick<
  SummaryContainerProps,
  'isExpanded' | 'height' | 'isLoading'
>

const SummaryWrapper = styled.div<SectionSummaryWrapperProps>`
  ${({
    isExpanded,
    height,
    isLoading,
    theme: {
      colors: { fillWeak, strokeBrand },
      spacing: { spacing16, spacing24 },
    },
  }) => css`
    position: relative;
    background-color: ${fillWeak};
    height: ${height ? `${height}px` : 'auto'};
    overflow: hidden;

    ${isExpanded &&
    css`
      height: auto;
    `}
    ${height &&
    css`
      min-height: ${height}px;
    `}

    ${!isLoading &&
    css`
      border-left: 2px solid ${strokeBrand};
      padding: ${spacing24} ${spacing16};

      ${desktopCSS(css`
        padding: ${spacing24};
        border-left: 4px solid ${strokeBrand};
      `)}
    `}
  `}
`

const SummaryContainer: FunctionComponent<SummaryContainerProps> = ({
  children,
  isExpanded = true,
  height,
  id,
  isLoading,
  ref = null,
}) => {
  return (
    <SummaryWrapper
      isExpanded={isExpanded}
      height={height}
      ref={ref}
      id={id}
      isLoading={isLoading}
    >
      {children}
    </SummaryWrapper>
  )
}

export default SummaryContainer
